import React from 'react';
import { KeyedMutator } from 'swr';
import { Controller, useForm } from 'react-hook-form';
import { ModalProps } from '../../../services/modals.service';
import { CleanUser } from '../../../export-types/cleaned-types';
import { useModalClose } from '../../../utils/useModalClose';
import { User, UserSelect } from '../../common/user-select';
import { InputWrapper } from '../../common/input-wrapper';
import { required } from '../../../utils/validations';
import { api } from '../../../services/api';
import { AlertService } from '../../../services/alert.service';

type AddObserverModalProps = ModalProps & {
  user: CleanUser;
  mutate?: KeyedMutator<any>;
};

export const AddObserverModal = ({
  user,
  close,
  mutate,
}: AddObserverModalProps) => {
  const modalRef = useModalClose(close);
  const { control, handleSubmit } = useForm<{ observer: User }>();

  const onSubmit = handleSubmit(async ({ observer }) => {
    try {
      await api.post(`/user/${user.id}/observers`, { userId: observer.id });
      AlertService.success();
      mutate?.();
      close();
    } catch (error: any) {
      AlertService.error(error?.message);
    }
  });

  return (
    <div className="modal-dialog mw-400" ref={modalRef}>
      <div className="modal-content">
        <div className="modal-header border-bottom-0 p-4">
          <button type="button" className="btn-close" onClick={close} />
        </div>
        <div className="modal-body pt-2 p-4">
          <h3 className="text-center mb-4">Добавить наблюдателя</h3>
          <form onSubmit={onSubmit}>
            <Controller
              control={control}
              name="observer"
              rules={{ ...required }}
              render={({ field, fieldState }) => (
                <InputWrapper
                  className="mb-3"
                  title="Наблюдатель"
                  required
                  error={fieldState.error?.message}
                >
                  <UserSelect
                    placeholder="Выберите наблюдателя"
                    {...field}
                    access="salesManager"
                    roles={['employee', 'admin']}
                  />
                </InputWrapper>
              )}
            />
            <button type="submit" className="btn btn-success w-100 mb-3">
              Добавить
            </button>
            <button
              type="button"
              className="btn btn-light w-100"
              onClick={close}
            >
              Отменить
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
